import React from 'react';
import './Skeleton.css';

interface SkeletonProps {
    width?: string;
    height?: string;
    borderRadius?: string;
    className?: string;
}

const Skeleton: React.FC<SkeletonProps> = ({
    width = '100%',
    height = '16px',
    borderRadius = '8px',
    className = ''
}) => (
    <div
        className={`skeleton ${className}`}
        style={{ width, height, borderRadius }}
    />
);

/* Pre-built skeleton patterns */

export const SkeletonCard: React.FC = () => (
    <div className="skeleton-card">
        <Skeleton height="120px" borderRadius="12px" />
        <div className="skeleton-card-body">
            <Skeleton width="70%" height="14px" />
            <Skeleton width="40%" height="12px" />
        </div>
    </div>
);

export const SkeletonList: React.FC<{ count?: number }> = ({ count = 3 }) => (
    <div className="skeleton-list">
        {Array.from({ length: count }).map((_, i) => (
            <div key={i} className="skeleton-list-item">
                <Skeleton width="48px" height="48px" borderRadius="50%" />
                <div className="skeleton-list-text">
                    <Skeleton width="60%" height="14px" />
                    <Skeleton width="80%" height="12px" />
                </div>
            </div>
        ))}
    </div>
);

export default Skeleton;
